module.exports = __webpack_public_path__ + "static/media/Screenshot (2)_1579097005624.30b4d4e8.png";